export const publications = [
  // 2025
  {
    title: "Deep learning phase pickers: how well can existing models detect hydraulic-fracturing induced microseismicity from a borehole array?",
    authors: "Lim, C.S.Y., Lapins, S., Segou, M., Werner, M.J.",
    journal: "Geophysical Journal International",
    volume: "240(1)",
    year: "2025",
    doi: "10.1093/gji/ggae386"
  },
  {
    title: "What caused the June 2024 seismic swarm near Lake Arenal, Costa Rica?",
    authors: "Lapins, S., Araya Rodriguez, M.C.",
    journal: "Seismica",
    year: "2025",
    status: "under review"
  },
  {
    title: "Using multi-station, multi-event spectral ratios to estimate geometrical spreading, Q attenuation and site corrections on local and regional seismic arrays",
    authors: "Lapins, S.",
    journal: "Seismological Research Letters",
    year: "2025",
    status: "under review"
  },
  {
    title: "Identifying fluids, faults and fractures: Insights from a deep-learning-derived seismic catalogue at Nabro volcano",
    authors: "Lapins, S., Kendall, J-M., Cashman, K.V., Goitom, B., Werner, M.J., Hammond, J.O.S., Ogubazghi, G.",
    journal: "Journal of Volcanology and Geothermal Research",
    year: "2025",
    status: "under review"
  },
  {
    title: "Evaluating the performance of Distributed Acoustic Sensing for Crosswell Seismic Imaging of Abandoned Mine Geothermal Systems",
    authors: "Holmgren, J., Butcher, A., Werner, M., Lapins, S., Chambers, J., Kendall, J-M., Rodríguez-Pradilla, G., Verdon, J.P., Starcher, V.",
    journal: "Geophysics",
    year: "2025",
    status: "under review"
  },
  {
    title: "Interconnectivity of Magmatic and Hydrothermal Systems of Aluto Volcano in the Main Ethiopian Rift inferred from Seismicity",
    authors: "Abraha, T.Y., Hudson, T., Kendall, J-M., Blundy, J.D., Tadesse, A.Z., Hammond, J.O., Ayele, A., Ogubazghi, G.M., Lapins, S.",
    journal: "Journal of Geophysical Research: Solid Earth",
    year: "2025",
    status: "under review"
  },
  // 2024
  {
    title: "DAS-N2N: machine learning Distributed Acoustic Sensing (DAS) signal denoising without clean data",
    authors: "Lapins, S., Butcher, A., Kendall, J-M., Hudson, T.S., Stork, A.L., Werner, M.J., Gunning, J., Brisbourne, A.M.",
    journal: "Geophysical Journal International",
    volume: "236(2)",
    year: "2024",
    doi: "10.1093/gji/ggad460",
    github: "https://github.com/sachalapins/DAS-N2N-torch"
  },
  // 2023
  {
    title: "Seismic tomography of Nabro caldera, Eritrea: insights into the magmatic and hydrothermal systems of a recently erupted volcano",
    authors: "Gauntlett, M., Hudson, T.S., Kendall, J-M., Rawlinson, N., Blundy, J.D., Lapins, S., et al.",
    journal: "Journal of Geophysical Research: Solid Earth",
    volume: "128(5)",
    year: "2023",
    doi: "10.1029/2022JB025742"
  },
  {
    title: "Hydrothermal fluids and where to find them: Using seismic attenuation and anisotropy to map fluids beneath Uturuncu volcano, Bolivia",
    authors: "Hudson, T.S., Kendall, J-M., Blundy, J.D., Pritchard, M.E., MacQueen, P., Wei, S.S., Gottsmann, J.H., Lapins, S.",
    journal: "Geophysical Research Letters",
    volume: "50(5)",
    year: "2023",
    doi: "10.1029/2022GL100974"
  },

  // 2021
  {
    title: "A Little Data Goes a Long Way: Automating Seismic Phase Arrival Picking at Nabro Volcano with Transfer Learning",
    authors: "Lapins, S., Goitom, B., Kendall, J-M., Werner, M.J., Cashman, K.V., Hammond, J.O.S.",
    journal: "Journal of Geophysical Research: Solid Earth",
    volume: "126(7)",
    year: "2021",
    doi: "10.1029/2021JB021910",
    github: "https://github.com/sachalapins/U-GPD"
  },

  // 2020
  {
    title: "Application of Machine Learning to Microseismic Event Detection in Distributed Acoustic Sensing (DAS) Data",
    authors: "Stork, A., Baird, A., Horne, S., Naldrett, G., Lapins, S., Kendall, J-M., Wookey, J., Verdon, J., Clarke, A., Williams, A.",
    journal: "Geophysics",
    volume: "85(5)",
    year: "2020",
    doi: "10.1190/geo2019-0774.1"
  },
  {
    title: "Lower-Crustal Seismicity on the Eastern Border Faults of the Main Ethiopian Rift",
    authors: "Lapins, S., Kendall, J-M., Ayele, A., Wilks, M., Nowacki, A., Cashman, K.V.",
    journal: "Journal of Geophysical Research: Solid Earth",
    volume: "125(8)",
    year: "2020",
    doi: "10.1029/2020JB020030"
  },
  {
    title: "An examination of the continuous wavelet transform for volcano-seismic spectral analysis",
    authors: "Lapins, S., Roman, D.C., Rougier, J., De Angelis, S., Cashman, K.V., Kendall, J-M.",
    journal: "Journal of Volcanology and Geothermal Research",
    volume: "389",
    year: "2020",
    doi: "10.1016/j.jvolgeores.2019.106728"
  }
];